import React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';

import { UserRole } from '@app/objects/User';

interface Props {
	roles: Array<UserRole>;
	notForRoot?: boolean;
	and?: boolean;
	or?: boolean;
}

const UserRoleAccess: React.FC<Props> = (props) => {
	const {
		roles, notForRoot, and = true, or = false, children,
	} = props;

	const { checkUserAccess } = useApplicationContext();

	return <>
		{((checkUserAccess(roles, { notForRoot }) && and) || or) && children}
	</>;
};

export default UserRoleAccess;
